import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';
import { uniqueId } from 'lodash';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

function getRowClass ( params ) {

    if ( params.data.orderingCode.toString() === params.data.tempCountingBundle.toString() ) {

        return 'selected-row';

    }
    return null;

}
function getRowStyleScheduled ( params ) {

    if ( params.data.transOrderNumber
        && params.data.orderNumber.toString() === params.data.transOrderNumber.toString() ) {

        return 'selected-row';

    }
    return null;

}

const buildWeekValueGetter = params => {

    if ( params.data.buildWeeek ) {

        const buildWeek = formatGivenDate( params.data.buildWeeek, 'YYYY-MM-DD' );

        if ( buildWeek === '' ) return ( <span>{buildWeek}</span> );
        if ( buildWeek === '2000-01-01' ) {

            return 'Inventory';

        } if ( buildWeek === '2000-02-01' ) {

            return 'Rework';

        }
        return buildWeek;

    }

};

let colDefsLinkedOrder = [
    {
        field: 'linkedOrderType',
        headerName: 'Linked Order Type',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'orderNumber',
        headerName: 'Order',
        sortable: true,
        filter: true,
        width: 65,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const linkObject = {
                pathname: ( `/${params.data.unitName}/order/information` ),
                key: uniqueId(),
                search: `?ordernum=${params.data.unitCode}${params.value}`
            };
            return ( <Link to={linkObject}>{params.data.unitCode}{params.value}</Link> );

        }
    },
    {
        field: 'factDlvyDate',
        headerName: 'FDD',
        sortable: true,
        filter: true,
        width: 67,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'YYYY-MM-DD' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'inventorySource',
        headerName: 'Inventory Source',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'baseCode',
        headerName: 'Base Code',
        sortable: true,
        filter: true,
        width: 78
    }
];

export const OrderInformationTable = props => {

    const colDefs = [
        {
            field: 'orderORGroup',
            headerName: 'Type',
            sortable: true,
            filter: true,
            width: props.transactionField ? 58 : 73,
            cellRenderer: params => {

                if ( params.value === '' ) return ( <span>{params.value}</span> );
                if ( ( params.data.reportType === 'Bundle' || params.data.reportType === 'Combo' ) && params.data.orderingCode === params.data.tempCountingBundle ) {

                    return ( <span className="orderGroupAstreik">*{params.value}</span> );

                }
                return ( <span className="orderGroup">{params.value}</span> );

            }
        },
        {
            field: 'orderingCode',
            headerName: 'Order Code',
            sortable: true,
            filter: true,
            width: props.transactionField ? 70 : 123,
            cellRenderer: params => {

                if ( params.value === '' ) return ( <span>{params.value}</span> );
                if ( ( params.data.reportType === 'Bundle' || params.data.reportType === 'Combo' ) && ( params.data.orderORGroup === 'B' || params.data.orderORGroup === 'P' ) ) {

                    return ( <a href={`/${params.data.unitName}/order/availability?constrainttype=BN&constraintkey=${params.value}&week=${params.data.buildWeeek}`} target="_blank" rel="noopener noreferrer">{params.value}</a> );

                } if ( params.data.orderORGroup === 'M' ) {

                    return ( <a href={`/${params.data.unitName}/order/availability?constrainttype=B&constraintkey=${params.value}&week=${params.data.buildWeeek}`} target="_blank" rel="noopener noreferrer">{params.value}</a> );

                } if ( params.data.orderORGroup === 'A' || params.data.orderORGroup === 'S' ) {

                    return ( <span>{params.value}</span> );

                }
                return ( <a href={`/${params.data.unitName}/order/availability?constrainttype=${params.data.orderORGroup}&constraintkey=${params.value}&week=${params.data.buildWeeek}`} target="_blank" rel="noopener noreferrer">{params.value}</a> );

            }
        },
        {
            field: 'orderingCodeQty',
            headerName: 'Qty',
            sortable: true,
            width: props.transactionField ? 55 : 60
        },
        {
            field: 'buildWeeek',
            headerName: 'Build Week',
            sortable: true,
            width: props.transactionField ? 75 : 120,
            valueGetter: buildWeekValueGetter
        }
    ];

    if ( props.transactionField ) {

        colDefs.push(
            {
                field: 'availableInd',
                headerName: 'Avail',
                sortable: true,
                filter: true,
                width: 60
            }
        );

    }
    return (
        <section className="atp-search-result-panel order-information-order-codes-result-panel">

            <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                <AgGridReactComponent
                    reactNext={true}
                    columnDefs={colDefs}
                    rowData={props.results}
                    onGridReady={onGridReady}
                    getRowClass={getRowClass}
                    headerHeight={props.transactionField ? 47 : 35}
                />
            </div>

        </section>
    );

};

OrderInformationTable.propTypes = {
    results: PropTypes.array.isRequired,
    transactionField: PropTypes.bool
};

export const LinkedOrderTable = props => {

    if ( props.transactionField ) {

        const colDefsTransaction = [
            {
                field: 'linkedOrderInd',
                headerName: 'Linked Ind',
                sortable: true,
                filter: true,
                width: 100
            },
            {
                field: 'orderNumber',
                headerName: 'Order',
                sortable: true,
                filter: true,
                width: 65,
                cellRenderer: params => {

                    if ( params.value === '' ) return ( <span>{params.value}</span> );
                    const linkObject = {
                        pathname: ( `/${params.data.unitName}/order/information` ),
                        key: uniqueId(),
                        search: `?ordernum=${params.data.unitCode}${params.value}`
                    };
                    return ( <Link to={linkObject}>{params.data.unitCode}{params.value}</Link> );

                }
            },
            {
                field: 'fdd',
                headerName: 'FDD',
                sortable: true,
                filter: true,
                width: 67,
                cellRenderer: params => {

                    if ( params.value === '' ) return ( <span>{params.value}</span> );
                    const dt = formatGivenDate( params.value, 'YYYY-MM-DD' );
                    return ( <span>{dt}</span> );

                }
            }
        ];
        colDefsLinkedOrder = colDefsTransaction;

    }
    return (
        <section className="atp-search-result-panel order-information-linked-order-result-panel">

            <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                <AgGridReactComponent
                    reactNext={true}
                    columnDefs={colDefsLinkedOrder}
                    rowData={props.results}
                    onGridReady={onGridReady}
                    headerHeight={47}
                    getRowClass={getRowStyleScheduled}
                />
            </div>

        </section>
    );

};

LinkedOrderTable.propTypes = {
    results: PropTypes.array.isRequired,
    transactionField: PropTypes.bool
};
